import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type CholesterolIconProps = Partial<SVGIconProps>;

const CholesterolIcon: FC<CholesterolIconProps> = (props) => (
  <SVGIcon viewBox="0 0 21 20" {...props}>
    <path
      d="M10 9.573c-.667 0-1.32-.198-1.875-.569s-.988-.898-1.243-1.515-.322-1.295-.192-1.95.452-1.256.924-1.728 1.073-.793 1.728-.924 1.333-.063 1.95.192 1.144.688 1.515 1.243.569 1.207.569 1.875A3.38 3.38 0 0 1 10 9.573zm2.813 1.319c.555-.371 1.207-.569 1.875-.569a3.38 3.38 0 0 1 3.375 3.375c0 .668-.198 1.32-.569 1.875s-.898.988-1.515 1.243-1.295.322-1.95.192-1.256-.452-1.728-.924-.793-1.073-.924-1.728-.063-1.333.192-1.95.688-1.144 1.243-1.515zm-9.375 0c.555-.371 1.207-.569 1.875-.569a3.38 3.38 0 0 1 3.375 3.375c0 .668-.198 1.32-.569 1.875s-.898.988-1.515 1.243-1.295.322-1.95.192-1.256-.452-1.728-.924-.793-1.073-.924-1.728-.063-1.333.192-1.95.688-1.144 1.243-1.515z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".125"
    />
  </SVGIcon>
);

export default CholesterolIcon;
